import { createBrowserRouter, Outlet } from 'react-router';
import { lazy, Suspense } from 'react';
import App from './App';
import RouteErrorBoundary from './RouteErrorBoundary';

const LogService = lazy(() => import('../features/log-service/LogService'));
const ApiService = lazy(() => import('../features/api-service/ApiService'));
const DeviceService = lazy(() => import('../features/device-service/DeviceService'));
const BPKManager = lazy(() => import('../bpk-manager'));
const ManagerLogin = lazy(() => import('../bpk-manager/manager-login'));
const ManagerMenu = lazy(() => import('../bpk-manager/manager-menu'));
const PullCashMain = lazy(() => import('../bpk-manager/pull-cash-main'));
const PullCashBox = lazy(() => import('../bpk-manager/pull-cash-box'));
const TestWebServices = lazy(() => import('../bpk-manager/test-web-services'));
const TestBarcode = lazy(() => import('../bpk-manager/test-barcode'));
const TestCash = lazy(() => import('../bpk-manager/test-cash'));
const TestCheck = lazy(() => import('../bpk-manager/test-check'));
const TestCamera = lazy(() => import('../bpk-manager/test-camera'));
const TestCard = lazy(() => import('../bpk-manager/test-card'));
const TestCardEmv = lazy(() => import('../bpk-manager/test-card-emv'));
const TestPrinter = lazy(() => import('../bpk-manager/test-printer'));
const TestReceipts = lazy(() => import('../bpk-manager/test-receipts'));
const ToggleOutOfService = lazy(() => import('../features/toggle-out-of-service/ToggleOutOfService'));

const withSuspense = (Component: React.ComponentType | React.LazyExoticComponent<React.ComponentType>) => (
	<Suspense fallback={null}>
		<Component />
	</Suspense>
);

export const router = createBrowserRouter([
	{
		path: '/',
		element: <App />,
		errorElement: <RouteErrorBoundary />,
	},
	{
		path: '/toggle-out-of-service',
		element: withSuspense(ToggleOutOfService),
		errorElement: <RouteErrorBoundary />,
	},
	{
		path: '/log-service',
		element: withSuspense(LogService),
		errorElement: <RouteErrorBoundary />,
	},
	{
		path: '/api-service',
		element: withSuspense(ApiService),
		errorElement: <RouteErrorBoundary />,
	},
	{
		path: '/device-service',
		element: withSuspense(DeviceService),
		errorElement: <RouteErrorBoundary />,
	},
	{
		path: '/manager',
		element: withSuspense(BPKManager),
		errorElement: <RouteErrorBoundary />,
		children: [
			{
				index: true,
				element: withSuspense(ManagerMenu),
			},
			{
				path: 'login',
				element: withSuspense(ManagerLogin),
			},
			{
				path: 'pull-cash',
				element: <Outlet />,
				children: [
					{
						index: true,
						element: withSuspense(PullCashMain),
					},
					{
						path: 'remove',
						element: withSuspense(PullCashBox),
					},
				],
			},
			{
				path: 'test-web-services',
				element: withSuspense(TestWebServices),
			},
			{
				path: 'test-barcode',
				element: withSuspense(TestBarcode),
			},
			{
				path: 'test-cash',
				element: withSuspense(TestCash),
			},
			{
				path: 'test-check',
				element: withSuspense(TestCheck),
			},
			{
				path: 'test-camera',
				element: withSuspense(TestCamera),
			},
			{
				path: 'test-card',
				element: withSuspense(TestCard),
			},
			{
				path: 'test-card-emv',
				element: withSuspense(TestCardEmv),
			},
			{
				path: 'test-printer',
				element: withSuspense(TestPrinter),
			},
			{
				path: 'test-receipts',
				element: withSuspense(TestReceipts),
			},
		],
	},
]);
